import mapButtonProps from './mapButtonProps';

export default function bodyTextWithDoubleCTAMapper(component) {
  let result = component;

  result = mapButtonProps(result, 'buttonProps');
  result = mapButtonProps(result, 'additionalButtonProps');

  return result;
}
